import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setUser } from 'actions/user';
import loadable from 'react-loadable';
import LoadingComponent from 'components/Loading';

// Estilos
import 'styles/antd.less';
import 'styles/bootstrap/bootstrap.scss';
import "styles/layout.scss";
import "styles/theme.scss";
import "styles/ui.scss";
import "styles/vendors.scss";

let AsyncAppLayout = loadable({
  loader: () => import('components/Layout/AppLayout/'),
  loading: LoadingComponent
});

let AsyncAccount = loadable({
  loader: () => import('routes/login/'),
  loading: LoadingComponent
});

let AsyncMapa = loadable({
  loader: () => import('routes/mapa/'),
  loading: LoadingComponent
});

class App extends React.Component {

  componentDidMount() {
    this.hydrateSession();
  }

  componentDidUpdate(prevProps) {
    // Si la ruta cambia, verificamos que la sesión siga existiendo
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.hydrateSession();
    }
  }

  hydrateSession = () => {
    const { pathname } = this.props.location;
    
    if (pathname === '/login' || pathname === '/mapa') return;

    const token = sessionStorage.getItem("token");
    const savedUser = sessionStorage.getItem("user_info");
    const savedPerms = sessionStorage.getItem("user_permissions");
    // 👉 1. Agregamos la recuperación de la llave del menú
    const savedMenu = sessionStorage.getItem("user_menu_tree"); 

    if (token && savedUser && savedPerms) {
      // Verificamos si Redux está vacío o si le falta específicamente el menuTree
      if (!this.props.user || !this.props.user.menuTree) {
        try {
          const userObj = JSON.parse(savedUser);
          const permsObj = JSON.parse(savedPerms);
          // 👉 2. Parseamos el menú si existe
          const menuTreeObj = savedMenu ? JSON.parse(savedMenu) : null;
          
          this.props.handleSetUser({
            ...userObj,
            permisos: permsObj,
            menuTree: menuTreeObj // 👉 3. Lo reinyectamos en Redux
          });
          
          console.log("Sesión y menú hidratados desde Storage");
        } catch (e) {
          console.error("Error al restaurar sesión", e);
          this.logout();
        }
      }
    } else {
      if (pathname.includes('/app')) {
        this.logout();
      }
    }
  }
  

  logout = () => {
    sessionStorage.clear();
    this.props.handleSetUser(null);
    this.props.history.push('/login');
  }

  render() {
    const { match, location } = this.props;
    const isRoot = location.pathname === '/' || location.pathname === '/app';

    if (isRoot) {
      return (<Redirect to={'/login'} />);
    }

    return (
      <div id="app">
        <Route path={`${match.url}mapa`} component={AsyncMapa} />
        <Route path={`${match.url}login`} component={AsyncAccount} />
        <Route path={`${match.url}app`} component={AsyncAppLayout} />
      </div>
    );
  }
}

// Mapeamos el estado para saber si ya tenemos al usuario en Redux
const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  handleSetUser: (user) => dispatch(setUser(user)),
});

// Usamos withRouter para tener acceso a history y location
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));